module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-italic.5711b84f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-italic.woff
// module id = 489
// module chunks = 0